import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

// this is just a pop up window that asks the user to confirm delete
export function DeleteConfirmationDialog({
  open,
  onClose,
  onConfirm,
  loading,
  objectToDelete,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "8px",
          // Matches your dark/premium Lionheart paper if needed
          backgroundColor: "#1e1e1e",
          color: "#fff",
        },
      }}
    >
      <DialogTitle
        id="delete-dialog-title"
        sx={{ fontWeight: "bold", fontSize: "1.4rem" }}
      >
        Confirm Deletion
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          id="delete-dialog-description"
          sx={{ color: "rgba(255,255,255,0.7)" }}
        >
          Are you sure you wish to delete this {objectToDelete}?
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ padding: "16px" }}>
        <Button
          variant="text"
          onClick={onClose}
          disabled={loading}
          sx={{
            color: "rgba(255,255,255,0.6)",
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={loading}
          startIcon={<DeleteIcon />}
          sx={{
            textTransform: "none",
            fontWeight: "bold",
            borderRadius: "6px",
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
